export default {
    intro: `Read the Writing Prompt and write your own text.<br />
            Read your friends' writing too, and vote for your favorites.`,
    buttons: {
        cancel: 'Cancel',
        submit: 'Submit',
    },
    options: {
        timer: {
            title: 'Timer Settings',
            inputTime: 'Writing Time',
            voteTime: 'Voting Time',
        },
        example: {
            title: 'Show Sample Answer',
            description: 'Sample answers will be shown on the Students\' screens.',
        },
        votesPerStudent: {
            title: 'Set Votes Per Student',
        },
    },
    noTitleCard: 'This card has no title',
    noContentCard: 'This card has no content',
    exampleAnswer: 'Sample Answer',
    tabs: {
        check: '1. Check Prompt',
        write: '2. Write Card',
        vote: '3. Voting',
        result: '4. Voting Results',
    },
    tabStudent: {
        write: 'Read the Writing Prompt and write your thoughts.',
        previousVote: 'Read your friends\' writing before voting.',
        vote: 'Vote for your favorite writing.',
        result: 'Check out your friends\' favorite writing!',
    },
    card: {
        title: 'No title was written \uD83D\uDE36',
        content: 'Nothing was written \uD83D\uDE35',
    },
    cardWritingArea: {
        titlePlaceholder: 'Please enter a title. (around 30 characters)',
        contentPlaceholder: 'Please enter the content. ',
        unsubmittedStudents: 'Not Submitted {count}',
    },
    loading: {
        voteStart: 'Start Voting',
        voteResult: 'Counting Votes',
        readNext: 'Preparing Next Prompt',
    },
    vote: {
        selfVote: 'You cannot vote for yourself',
        voteLimit: 'You have used all your votes.',
    },
    student: {
        inPlay: {
            readyText: `Read the Writing Prompt and<br />think about what you want to write.`,
            topic: 'Writing Prompt',
            foldTopic: 'Fold Prompt',
            imageAlt: 'Image Resource',
            voteRemaining: '{count} votes remaining',
            waiting: 'Waiting',
        },
        toast: {
            contentLengthWarning: 'Content must be 2,000 characters or less.',
            titleLengthWarning: 'Title must be 30 characters or less.',
            inputEndWarning: '15 seconds left. Writing time is about to end.',
            voteEndWarning: '15 seconds left. Voting is about to end.',
        },
    },
    teacher: {
        setting: {
            titlePlaceholder: 'Please enter a Writing Prompt title. (max 200 characters)',
            textPlaceholder: 'Please enter a Writing Prompt description. (max 1,000 characters)',
            inputErrorMessage: 'Please enter a value',
            delete: 'Delete',
            register: 'Save',
            cancel: 'Cancel',
            addQuestion: 'Add Writing Prompt',
        },
        inPlay: {
            readyTextInput: `After explaining the Writing Prompt, <br />
                                    press 'Start Writing'`,
            readyTextSubmit: `When Students submit, <br />
                                    it will appear here.`,
        },
        modal: {
            title: 'Card Writing \uD83D\uDCAC',
            startConfirm: {
                message: 'You have content being written to add a Writing Prompt.',
                subMessage: 'If you start the Activity now, all written content will be deleted and not added as a question.',
                optionalMessage: 'Do you still want to start the Activity?',
                confirmText: 'Start Activity',
                cancelText: 'Continue Writing',
            },
            voteStart: {
                message: 'Some Students are still writing.',
                subMessage: 'Submit the cards as they are and start voting?',
                confirmText: 'Start Voting',
            },
            voteEnd: {
                message: 'Voting time has ended.',
                subMessage: 'Would you like to check the results?',
                confirmText: 'Check Results',
            },
            questionDelete: {
                message: 'Delete this Writing Prompt?',
                subMessage: 'Deleted Writing Prompts cannot be recovered.',
                confirmText: 'Delete',
            },
        },
        button: {
            step: {
                beforeStart: 'Start Writing',
                writingEnd: 'End Writing',
                voteEnd: 'End Voting',
                nextTopic: 'Next Prompt',
                activityStart: 'Start Activity',
            },
        },
        result: {
            topic: 'Writing Prompt',
        },
    },
};
